
    import { defineComponent} from 'vue'
    export default defineComponent({
        setup() {
          const language = localStorage.getItem('lang') || navigator.language.substr(0, 2)
          const handleGoAgreement = (url: string) => {
            const href = `${location.origin}/vshow-main` + url + '-' + language + '.html'
            window.open(href, '_blank')
          }
          return {
            handleGoAgreement
          }
        },
    })
